exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-contact-js": () => import("./../../../src/pages/contact.js" /* webpackChunkName: "component---src-pages-contact-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-project-140-js": () => import("./../../../src/pages/project/140.js" /* webpackChunkName: "component---src-pages-project-140-js" */),
  "component---src-pages-project-187-js": () => import("./../../../src/pages/project/187.js" /* webpackChunkName: "component---src-pages-project-187-js" */)
}

